// release-worktree-clean-before-deploy.ts
//
// Close-out A3 (Luke Q2, 2026-09-30): the deploy recipe runs IN the mission
// worktree, but G3 approved a candidate commit. Anything uncommitted there —
// a file a worker session left behind, an edit made by hand after review — is
// deployed without being in the candidate anybody looked at. So the worktree
// must be clean (`git status --porcelain`, which already honours .gitignore and
// the mission's info/exclude entries) immediately before the deploy side
// effect; otherwise the release stops at `deploy_blocked` and the next `run`
// retries once it is clean. A failed `git status` is not "clean": fail closed.
import type { GitRunner } from "./commit-owner-git-ops.js";
import { realGitRunner } from "./supervisor-git-runner.js";

/** How many offending paths the reason lists before summarising the rest. */
const LISTED_PATHS = 10;

/** `undefined` when the worktree is clean; otherwise why deploy must not run. */
export async function releaseWorktreeDirtyReason(
  repoDir: string,
  gitRunner: GitRunner = realGitRunner,
): Promise<string | undefined> {
  // L3 (review P2): a global `diff.ignoreSubmodules=all` must not hide a dirty submodule.
  const res = await gitRunner(
    ["status", "--porcelain=v1", "--untracked-files=all", "--ignore-submodules=none"],
    repoDir,
  );
  if (res.status !== 0) {
    return (
      `không kiểm được worktree mission trước deploy (git status exit ${res.status}: ` +
      `${res.stderr.trim()}) — chặn deploy (fail-closed).`
    );
  }
  const entries = res.stdout.split("\n").filter((line) => line.trim().length > 0);
  if (entries.length === 0) return undefined;
  const shown = entries.slice(0, LISTED_PATHS).map((line) => line.trim());
  const more = entries.length > LISTED_PATHS ? ` (+${entries.length - LISTED_PATHS} nữa)` : "";
  return (
    `worktree mission có ${entries.length} thay đổi chưa commit — deploy sẽ chạy trên cây khác ` +
    `candidate G3 đã duyệt nên chặn: ${shown.join("; ")}${more}. Xem bằng \`git -C ${repoDir} status\`, ` +
    "dọn (commit qua ticket hoặc xoá; recipe release chỉ nên ghi vào chỗ bị ignore) rồi chạy lại " +
    "`avatar autopilot run`."
  );
}
